import React from "react";
import CountUp from "react-countup";

const CARDS = [
  {
    key: "upcoming",
    label: "Upcoming Earnings",
    sub: "Scheduled Payments",
    icon: "fa-solid fa-hourglass-half",
    color: "#E8A840",
    bg: "#FBF5E0",
    border: "#FDE68A",
  },
  {
    key: "paid",
    label: "Paid",
    sub: "Successfully received",
    icon: "fa-solid fa-circle-check",
    color: "#7EC8A0",
    bg: "#E8F6EE",
    border: "#A7F3D0",
  },
];

const EngineerInvoiceStats = ({ data }) => {
  if (!data) return null;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      {CARDS.map((card) => {
        const { count = 0, total = 0 } = data[card.key] ?? {};
        return (
          <div
            key={card.key}
            className="bg-white rounded-2xl shadow-sm p-5 flex flex-col gap-3"
            style={{ border: `1.5px solid ${card.border}` }}
          >
            {/* header */}
            <div className="flex items-center gap-3">
              <div
                className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: card.bg }}
              >
                <i className={`${card.icon} text-base`} style={{ color: card.color }} />
              </div>
              <div>
                <p className="text-sm font-bold text-gray-700 leading-none ">{card.label}</p>
                <p className="text-[11px] text-gray-500 mt-0.5">{card.sub}</p>
              </div>
            </div>

            {/* grand total — main number */}
            <div>
              <p className="text-[10px] text-gray-400 uppercase font-medium tracking-wider mb-1">
                Grand Total
              </p>
              <p className="text-3xl font-extrabold leading-none" style={{ color: card.color }}>
                <span className="text-base font-semibold text-gray-300 mr-0.5">$</span>
                <CountUp start={0} end={total} duration={1.3} decimals={0} separator="," />
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default EngineerInvoiceStats;
